"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnotationResultState = exports.currentProtocolVersion = void 0;
/**
 * The current version of the message protocol. This is incremented when there are significant
 * changes to the flow of messages in a session, or breaking changes to individual message
 * schemas occur, but typically not when individual message schemas are updated in backward and
 * forward compatible ways.
 */
exports.currentProtocolVersion = 2;
var AnnotationResultState;
(function (AnnotationResultState) {
    /**
     * No workflows are currently running and no annotation results will be produced until
     * additional SyncMessages are received.
     */
    AnnotationResultState[AnnotationResultState["Idle"] = 0] = "Idle";
    /**
     * Workflows are currently running and/or the client has just activated the annotation type;
     * more results may arrive. This is the default state after the first activation of a given
     * annotation type.
     */
    AnnotationResultState[AnnotationResultState["Pending"] = 1] = "Pending";
})(AnnotationResultState = exports.AnnotationResultState || (exports.AnnotationResultState = {}));
//# sourceMappingURL=messages.js.map